import * as React from 'react';
import * as PropTypes from 'prop-types';
import { Accordion } from 'react-bootstrap';
import { SContainer, PrimaryText, SAnchor } from './style';

const TOCItems = ({ as = 'ol', items = [] }) => {
  const ListContainer = as;

  const onClickHandler = id => {
    document.querySelector(id).scrollIntoView();
  };

  return (
    <ListContainer>
      {items.length > 0 &&
        items.map(({ url, title, items: subItems }) => (
          <li key={url}>
            <SAnchor onClick={() => onClickHandler(url)}>{title}</SAnchor>
            {subItems && subItems.length > 0 && (
              <TOCItems as="ul" items={subItems} />
            )}
          </li>
        ))}
    </ListContainer>
  );
};

const SinglePostTOC = ({ toc }) => {
  return (
    <SContainer>
      <Accordion defaultActiveKey="0">
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <PrimaryText>Table of Contents</PrimaryText>
          </Accordion.Header>
          <Accordion.Body>
            {toc && toc.items.length > 0 && <TOCItems items={toc.items} />}
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </SContainer>
  );
};

SinglePostTOC.propTypes = {
  toc: PropTypes.any,
};

TOCItems.propTypes = {
  as: PropTypes.string,
  items: PropTypes.any,
};

export default SinglePostTOC;
